/*
 * 接口库
 * 用法：import api from 'api'
 *
 */
const config = require('@/config');

/**
 * `require.context` 是一个webpack的api
 * 通过执行`require.context` 函数获取一个特定的上下文，用来实现自动化导入模块。
 */
const files = require.context('./modules', false, /\.js$/)
const modules = {}

files.keys().forEach((key) => {
    // 忽略掉 index.js
    if (key === './index.js') return
    // 读取文件中的 default 模块
    // modules[key.replace(/(\.\/|\.js)/g, '')] = files(key).default
    Object.assign(modules, files(key).default)
})

export default {
    wsBrowserUrl:`${config.wsURL}/browser`,     // 培训师websocket
    wsTraineeUrl:`${config.wsURL}/trainee`,     // 学员的websocket
    simpleUploadURL: `${config.baseUrl}/fileapi/uploader/resource`,  //全局上传的地址
    fileUploadURL: `${config.baseUrl}/fileapi/FileUploader`,      //上传图片地址(头像/Avatar、封面/Cover)
    topicImportUploadURL: `${config.baseUrl}/fileapi/TopicImportUploader`,
    zipUploaderURL: `${config.baseUrl}/fileapi/uploader/zip`,  // 临时图像库上传地址
    attachmentUploaderURL: `${config.baseUrl}/fileapi/uploader/attachment`, // 附件上传地址
    timeSheetUploaderURL: `${config.baseUrl}/clockApi/accessory`, // 考勤打卡上传地址
    mobileStudyUrl: config.mobileStudyUrl,
    imagePanoramicHost: config.imagePanoramicHost,

    ...modules
}
